import { axios } from "@/plugins/http-request.js";

const state = {};

const getters = {};
const actions = {
  getSupplierList(_, payload) {
    return axios
      .get(`api/fulfillmentbb/b2b_supplier_list`, {
        params: payload,
      })
      .then((res) => res.data);
  },
  getMappedSupplierList(_, payload) {
    return axios
      .get(`api/fulfillmentbb/b2b_supplier_mapping_list`, {
        params: payload,
      })
      .then((res) => res.data);
  },
  linkedSupplier(_, payload) {
    return axios
      .post(`api/fulfillmentbb/b2b_linking_supplier`, payload)
      .then((res) => res.data);
  },
  unlinkedSupplier(_, payload) {
    return axios
      .patch(`api/fulfillmentbb/b2b_unlinking_supplier/${payload.id}`)
      .then((res) => res.data);
  },
  addSupplier(_, payload) {
    return axios
      .post(`api/fulfillmentbb/b2b_create_supplier_mapping`, payload)
      .then((res) => res.data);
  },
  syncSupplier() {
    return axios
      .get(`/api/fulfillmentbb/b2b_sync_supplier`)
      .then((res) => res.data);
  },
};

const mutations = {};

export default {
  state,
  getters,
  actions,
  mutations,
};
